import { useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000";

export default function RefRedirect() {
  const { code } = useParams();

  useEffect(() => {
    const track = async () => {
      try {
        await axios.get(`${API_URL}/api/influencer/ref/${code}?noRedirect=1`);
      } catch (e) {
        console.error("Referral tracking failed", e);
      } finally {
        window.location.replace(`/register?ref=${code}`);
      }
    };
    track();
  }, [code]);

  return <p>Redirecting…</p>;
}
